// @flow

export function bem (base: string, ...modifiers: Array<?string>): string {
  return [
    base,
    ...modifiers.filter(Boolean).map(modifier => {
      return `${base}--${modifier}`
    })
  ].join(' ')
}



// WEBPACK FOOTER //
// ./src/shared/helpers/bem.js